import React from 'react';
import { Button } from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import Table from '../../../shared/table/Table';

const ServicesTable = ({ data, page, handleUpdate, handleDelete }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>العنوان</th>
        <th>الوسوم</th>
        <th>الترتيب</th>
        <th>الحالة</th>
        <th>إجراءات</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((service, idx) => (
        <tr key={service._id}>
          <td>{(page - 1) * 10 + idx + 1}</td>
          <td>{service.title}</td>
          <td>{service.tags?.join(', ')}</td>
          <td>{service.order}</td>
          <td>{service.is_active ? 'نشط' : 'معطل'}</td>
          <td>
            <Button bg="transparent" color="green" size="xs" onClick={() => handleUpdate(service)}>
              <FiIcons.FiEdit size={20} />
            </Button>
            <Button bg="transparent" color="red.600" size="xs" onClick={() => handleDelete(service)}>
              <FiIcons.FiDelete size={20} />
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default ServicesTable;
